// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__N051f","choiceBoxes":"toolbarselects_choiceBoxes__VR-jN","simpleField":"toolbarselects_simpleField__1UqnR"};